import type { ScreenTourMap } from './types';

/** Administrar › Sedes. */
export const officeTours: ScreenTourMap = {
  '/admin/offices': {
    key: 'screen-offices',
    steps: [
      { text: 'tours.offices.welcome' },
      { text: 'tours.offices.new', target: 'offices-new' },
      { text: 'tours.offices.search', target: 'offices-search' },
      { text: 'tours.offices.export', target: 'offices-export' },
      { text: 'tours.offices.table', target: 'offices' },
      { text: 'tours.offices.sort', target: 'offices-col-name' },
      { text: 'tours.offices.actions', target: 'offices-actions' },
      { text: 'tours.offices.pagination', target: 'offices-pagination' },
    ],
  },
};
